import { GridColDef } from "@mui/x-data-grid";
import DetailButton from "./DetailButton";

export const examTypeCategoryColumns: GridColDef[] = [
  {
    field: "",
    renderCell: DetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "categoryCode",
    minWidth: 150,
    headerName: "Kategory Kodu",
    sortable: false,
    filterable: false,
  },
  {
    field: "categoryName",
    headerName: "Kategori Adı",
    flex: 1,
    minWidth: 80,
  },
];
